import React from "react";
import Icon from "./icon";

function TrainingAndDevelopmentIcon(props) {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <g>
        <g>
          <path d="M256,0C114.623,0,0,114.614,0,256c0,141.377,114.623,256,256,256c141.386,0,256-114.623,256-256
			C512,114.614,397.386,0,256,0z M295.431,428.898c0,9.123-7.388,16.506-16.502,16.506h-43.096c-9.118,0-16.502-7.388-16.502-16.506
			V321.295c0-9.114,7.383-16.511,16.502-16.511h43.096c9.114,0,16.502,7.401,16.502,16.511V428.898z M300.194,150.686
			c0,0-15.316,5.498-15.316,13.487v113.384h-54.291V164.173l-30.875-3.01c0,13.293-10.778,15.041-24.071,15.041h-2.258
			c-13.293,0-24.071-10.783-24.071-24.071v-48.147c0-13.293,10.783-24.071,24.071-24.071h2.258c13.297,0,24.071,1.753,24.071,15.041
			l24.071-7.175l69.996,1.226c39.63,0.297,71.669,40.847,71.669,80.544C365.453,169.556,341.599,148.765,300.194,150.686z"></path>
        </g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    </Icon>
  );
}
export default TrainingAndDevelopmentIcon;
